import React, { useState } from "react";
import LoadingSpinner from "../../../../components/Loadder"; 
import { postData, getData } from "../../../../serverRequest";
import Select from 'react-select';

export default function ServiceReportForm(props) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [serviceName, setServiceName] = useState("");  
  const [userCount, setUserCount] = useState("");  
  const [startDate, setStartDate] = useState("");
  const [expireDate, setExpireDate] = useState("");
  const [licenseEdition, setLicenseEdition] = useState("");
  const [computerId, setComputerId] = useState("");
  const [vendor, setVendor] = useState("");
  const [invoiceDetails, setInvoiceDetails]  = useState("");
  const [amount, setAmount] = useState("");
  const [entityName, setEntityName] = useState("");
  const [subscriptionPeriod, setSubscriptionPeriod] = useState("");
  const [totalEntities, setTotalEntities] = React.useState([]);  
  const filterEntityData = (entities_data) => {
    //console.log(tickets_data);
    let totalEntity = [];
    if (entities_data) {
      for (let i = 0; i < entities_data.length; i++) {
        totalEntity.push(entities_data[i])
      }
    }

    setTotalEntities(totalEntity);
    return ({ "total": totalEntity })
  }

   React.useEffect(() => {
     async function fetchData() {
        setLoading(true);
       let resData = await getData('/api/company?admin=1')
       let entities_data = resData['data']['entities']
       console.log(entities_data);
       let entitiesData = await filterEntityData(entities_data)
 
 
       setLoading(false);
     }
     fetchData();
 
 
   }, []) 

  const handleSubmit = async (event) => {
    event.preventDefault();  
    setLoading(true);
  
    const formData = {
      'service_name': serviceName ? serviceName : '',
      'user_count': userCount ? userCount : '',
      'start_date': startDate ? startDate : '',
      'expire_date': expireDate ? expireDate :'',
      'license_edition': licenseEdition ? licenseEdition : '',
      'computer_id': computerId ? computerId :'',
      'vendor': vendor ? vendor : '',
      'invoice_details': invoiceDetails ? invoiceDetails : '',
      'amount': amount ? amount : '',
      'entity_name': entityName ? entityName : '',
      'subscription_period': subscriptionPeriod ? subscriptionPeriod : '',
    };
  
    try {
      console.log(formData)
      const res = await postData('/api/product/productservice/', formData);
      console.log(res);
      if (res['data']['code'] === 200) {
        setLoading(false);
        setShowModal(true);
        alert('Service report submitted successfully');
        window.location.href = '/admin/reports/serviceReport';
      } else {
        alert('Service report submission failed');
        console.error('Failed to submit form:', res.statusText);
        setLoading(false);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setLoading(false);
    }
  };  
  
  return (
    <div className="service-report-form-container p-4 pt-0 min-h-screen w-full">
      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <form onSubmit={handleSubmit}> 
          <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            <div className="rounded-t bg-white mb-6 px-6 py-6">
              <div className="text-center flex justify-between">
                <h6 className="text-blueGray-700 text-xl font-bold">Service Report Form</h6>
              </div>
            </div>            
            <div className="flex flex-wrap justify-between">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Entity Name</label>
                  <select
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="entityName"
                    value={entityName}
                    onChange={(e) => setEntityName(e.target.value)}
                  >
                    <option value="">Select Entity</option>
                    {totalEntities.map((entity, index) => (
                      <option key={index} value={entity.company_code}>
                        {entity.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">  
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Service Name</label>
                  <input type="text"
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name= "serviceName" defaultValue={serviceName} onChange={(e) => setServiceName(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">User Count</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="userCount" defaultValue={userCount} onChange={(e) => setUserCount(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Start Date</label>
                  <input type="date" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="startDate" defaultValue={startDate} onChange={(e) => setStartDate(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Expire Date</label>
                  <input type="date" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="expireDate" defaultValue={expireDate} onChange={(e) => setExpireDate(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">License Edition</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="licenseEdition" defaultValue={licenseEdition} onChange={(e) => setLicenseEdition(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Computer ID</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="computerId" defaultValue={computerId} onChange={(e) => setComputerId(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Vendor</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="vendor" defaultValue={vendor} onChange={(e) => setVendor(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Invoice Details</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="invoiceDetails" defaultValue={invoiceDetails} onChange={(e) => setInvoiceDetails(e.target.value)} />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Amount</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="amount" defaultValue={amount} onChange={(e) => setAmount(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="flex flex-wrap">

              <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full mb-3">
                  <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">Subscription Period</label>
                  <input type="text" 
                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    name="subscriptionPeriod" defaultValue={subscriptionPeriod} onChange={(e) => setSubscriptionPeriod(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="text-center mt-6 lg:w-3/12 px-4">
              <input
                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-4 w-full ease-linear transition-all duration-150"
                type="Submit"
                value="Submit"
              />                            
            </div>
          </div>
        </form>
      )}
    </div>
  );
}
